import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import AccountAccessOptions, {
  AccountAccessOptionsFields,
} from 'src/components/AccountAccessOptions/AccountAccessOptions'
import { OrganizationRoles } from 'src/enums'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface OrgRoleRadioItemProps {
  title: React.ReactElement
  description: React.ReactElement | string
  hoveredRole?: OrganizationRoles
  bookkeeperSelected?: boolean
  setAccountAccess?: (fields: AccountAccessOptionsFields) => void
  setRole?: () => void
  role: OrganizationRoles
  selectedRole: OrganizationRoles | undefined
}
const OrgRoleRadioItem: React.FC<OrgRoleRadioItemProps> = (
  props,
): React.ReactElement => {
  const user = useSelector(selectUserListModelFromState)
  useEffect(() => {
    if (props.setRole && props.selectedRole === props.role) {
      props.setRole()
    }
  }, [props.selectedRole])

  return (
    <span>
      <p
        css={css`
          ${getFontCss(
            16,
            props.role === props.selectedRole ||
              props.role === props.hoveredRole
              ? themeConstants.colors.cta
              : styleConstants.colors.black,
            styleConstants.fontFamilies.medium,
          )};
          padding-bottom: 4px;
        `}
      >
        {props.title}
      </p>
      <p
        css={css`
          ${getFontCss(
            12,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        {props.description}
      </p>
      <>
        {props.selectedRole === OrganizationRoles.bookkeeper &&
          props.setAccountAccess !== undefined && (
            <AccountAccessOptions
              updateAccess={props.setAccountAccess}
              useDefaults
              selectedRole={props.selectedRole}
              userRole={user?.organizationRole}
            />
          )}
      </>
    </span>
  )
}

export default OrgRoleRadioItem
